import React from 'react';

import ApiTokenForm from './ApiTokenForm';

interface IProps {
  tokenApi: string;
  loading: boolean;
  handleTokenApi: (tokenApi: string) => void;
}

function FacebookForm({ loading, handleTokenApi, tokenApi }: IProps) {
  return (
    <>
      <div className='mt-2' />
      <ApiTokenForm loading={loading} tokenApi={tokenApi} handleTokenApi={handleTokenApi} />
    </>
  );
}

export default React.memo(FacebookForm);
